// haptic.js — Haptic feedback utility
const PATTERNS = {
  tap: [10],
  success: [15, 50, 15],
  error: [50, 30, 50, 30, 50],
  heavy: [30],
  double: [15, 40, 15],
};

export function haptic(type = 'tap') {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    try {
      navigator.vibrate(PATTERNS[type] || PATTERNS.tap);
    } catch (e) {
      // Silent fallback
    }
  }
}

export default haptic;